import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FeedbackTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function FeedbackListSubTab() {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFeedback();
  }, []);

  const fetchFeedback = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/feedback`);
      setFeedback(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке обратной связи: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить это обращение?')) {
      try {
        await axios.delete(`${API_URL}/api/feedback/${id}`);
        fetchFeedback();
      } catch (err) {
        setError('Ошибка при удалении обращения: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="feedback-tab">
      <div className="tab-header">
        <h2>Обратная связь</h2>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Текст обращения</th>
              <th>Вопрос</th>
              <th>Telegram ID</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {feedback.length === 0 ? (
              <tr>
                <td colSpan="5" className="empty-state">
                  Нет обращений. Обратная связь будет отображаться здесь.
                </td>
              </tr>
            ) : (
              feedback.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td className="feedback-text">{item.text}</td>
                  <td className="question-text">
                    {item.question_text || `ID вопроса: ${item.question_id}`}
                  </td>
                  <td>{item.telegram_id}</td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(item.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FeedbackListSubTab;
